import Image from "next/image";
import React from "react";
import ExternalLinkButton from "./ExternalLinkButton";
import IntegrationLogo from "./IntegrationLogos";
import { container_classname, sub_section_heading } from "./constants";
import { MdKeyboardArrowRight } from "react-icons/md";

const IntegrationSection: React.FC<{ isLight?: boolean; removeCTA?: boolean }> = ({ isLight = false, removeCTA = false }) => {
    const bgColor = isLight ? "white" : "linear-gradient(103deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%)";
    return (
        <section className="lg:py-20 py-10" style={{ background: bgColor }}>
            <div className={`${container_classname} flex flex-col lg:gap-20 gap-6`}>
                <div className="flex lg:flex-row flex-col lg:justify-between gap-10">
                    <div className="lg:w-1/2 w-full lg:py-0 py-5">
                        <h2 className={`${sub_section_heading} mb-5`} style={{ fontFamily: "Degular Display" }}>
                            Connect everything you already use
                        </h2>
                        <p className="text-gray-700 text-md mb-8">
                            Gallabox integrates with Zoho CRM, Google Calendar, Razorpay, Google Sheets, Calendly, Zoom, and Zapier. Make WhatsApp and Instagram automation work
                            seamlessly with your existing tools, not add another system to manage.
                        </p>
                        {!removeCTA && (
                            <ExternalLinkButton href="/whatsapp-integrations" target="_blank" rel="noreferrer">
                                <span className="flex items-center">
                                    View all Integrations{" "}
                                    <span>
                                        <MdKeyboardArrowRight />
                                    </span>
                                </span>
                            </ExternalLinkButton>
                        )}
                    </div>
                    <div className="lg:w-1/2 lg:flex hidden lg:items-center lg:justify-center" style={{ height: "163px" }}>
                        <Image height={163} width={500} src="https://assets.gallabox.com/gb-home/new-landing/integration/integration.png" alt="whatsapp icon" />
                    </div>
                </div>
            </div>
            <div className="lg:pt-20 lg:pb-0 py-6">
                <IntegrationLogo />
            </div>
        </section>
    );
};

export default IntegrationSection;
